module.exports = __webpack_public_path__ + "img/Aurora_E_sleeve.77712fdb.svg";